var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2.4 -2.4 28.8 28.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_line_ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.19995L2.40002 8.39995V22.7999H8.40002V14.4H15.6V22.7999H21.6V8.39995L12 1.19995Z",
    stroke: "#000000",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeLine);
export default __webpack_public_path__ + "static/media/ic_home_line.b479f23526e5f5adcc8352ed055631af.svg";
export { ForwardRef as ReactComponent };